import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Controlling');

export const ACTIVITYREASON_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.ActivityReason.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
];

export const ACTIVITYREASON_CONFIG = {
  entityName: 'ActivityReason',
  localizationKey: 'Controlling::Entity.ActivityReason',
  fields: ACTIVITYREASON_FIELDS,
  permission: 'ControllingActivities.ActivityReasons',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Activities + MENU_NAME_SUFFIX,
};
